var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-slide-right","mode":"out-in","appear":""}},[_c('section',[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.$currentCollection.claim)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$themedContent.claim)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }